<ng-container [ngSwitch]="item?.ItemType">
  <fgbcl-auction-won-list-item
    *ngSwitchCase="itemType?.Auction"
    [auctionItem]="item"
    [redeemed]="true"
  ></fgbcl-auction-won-list-item>
  <fgbcl-marketplace-purchased-list-item
    *ngSwitchCase="itemType?.Marketplace"
    [purchaseItem]="item"
    [redeemed]="true"
  ></fgbcl-marketplace-purchased-list-item>
  <fgbcl-lottos-won-list-item *ngSwitchCase="itemType?.Lotto" [lottoItem]="item" [redeemed]="true"></fgbcl-lottos-won-list-item>
</ng-container>
